import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import { PRODUCT_CATEGORIES } from "@/data/products";

export default function ProductCategoriesSection() {
  const { t } = useLanguage();

  return (
    <section className="bg-white section-padding px-4 sm:px-6 lg:px-8">
      <div className="content-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
            <p className="label-overline text-steel mb-2">{t("productScope")}</p>
            <h2 className="font-display font-bold text-2xl md:text-3xl text-primary-deep">{t("productCategoriesTitle")}</h2>
          </motion.div>
          <motion.div initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
            <Link to="/products" className="inline-flex items-center gap-2 text-sm font-semibold text-secondary-blue hover:text-primary-deep transition-colors">
              {t("viewAll")} <ArrowRight className="w-4 h-4" />
            </Link>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PRODUCT_CATEGORIES.map((cat, i) => (
            <motion.div
              key={cat.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: [0.25, 0.46, 0.45, 0.94] }}
            >
              <Link to={cat.link} className="group block relative overflow-hidden rounded-xl aspect-[4/3]">
                <img src={cat.image} alt={cat.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                <div className="absolute inset-0 bg-primary-deep/50 group-hover:bg-primary-deep/30 transition-colors duration-300" />
                <div className="absolute inset-0 flex flex-col justify-end p-5">
                  <h3 className="font-display font-bold text-white text-lg leading-tight mb-1">{cat.title}</h3>
                  <p className="text-sm text-white/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300">{cat.description}</p>
                </div>
                <div className="absolute top-4 right-4 w-9 h-9 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 group-hover:bg-white">
                  <ArrowRight className="w-4 h-4 text-primary-deep" />
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
